import { CaptchaViewer, Typography } from '@p2p/components';
import { MainContainer } from '@p2p/entities/payment';
import { useCallback } from 'react';

import styles from './CheckUser.module.scss';
import { CheckUserProps } from './CheckUser.types';

export const CheckUser = ({ pageSettings, onSuccess }: CheckUserProps) => {
  const handleSuccess = useCallback(() => {
    onSuccess?.();
  }, [onSuccess]);

  return (
    <MainContainer className={styles.wrapper} maxWidth="400px">
      <Typography variant="h1" color="heading">
        Вы не робот?
      </Typography>
      <Typography variant="text-l-medium" className={styles.description}>
        {`Пройдите проверку, чтобы получить\nреквизиты и оплатить заявку.`}
      </Typography>
      <div className={styles.captchaContainer}>
        <CaptchaViewer onSuccess={handleSuccess} pageSettings={pageSettings} />
      </div>
    </MainContainer>
  );
};
